import React, { Component, Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import autoBind from 'react-autobind';
import { ddados } from '../solicitarBaixaMei.ddados';
import DDadosItem from '@common/components/ddados/ddados.item';
import { connect } from '@common/components/base.component';
import solicitarBaixaMeiSelector from '../store/solicitarBaixaMei.selectors';
import solicitarBaixaMeiActions from '../store/solicitarBaixaMei.actions';
import Form from '@common/externos/components/validation/form.validation';
import SolicitarBaixaMeiDadosModal from './solicitarBaixaMeiDados.modal';
import EnumFormaGerarSenha from '@/modules/redeSIM/enumFormaGerarSenha';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onSubmit(data) {
    this.props.solicitarBaixaMeiActions.confirmarSenhaSolicitarBaixaMei(data);
  }

  toggleModal() {
    this.props.solicitarBaixaMeiActions.setSolicitarBaixaMei({
      SolicitacaoBaixaMeiDados: [],
      GridSolicitarBaixaMeiPesquisa: [],
      SolicitarBaixaMeiModalToggle: false,
      FormaGerarSenha: undefined,
    });
  }

  render() {
    const { Campos } = ddados;
    const { solicitarBaixaMei } = this.props.solicitarBaixaMeiSelector;

    return (
      <>
        {solicitarBaixaMei.ShowBaixaMeiDadosModal && <SolicitarBaixaMeiDadosModal />}

        {!solicitarBaixaMei.ShowBaixaMeiDadosModal && (
          <Form onSearchSubmit={this.onSubmit} onCancel={this.toggleModal} fromModal={true}>
            {(form) => (
              <div elementID="2">
                <Modal.Header>
                  <Modal.Title>
                    <h3>Pesquisa MEI TB</h3>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col>
                      <DDadosItem
                        name="CnpjEmpresa"
                        {...Campos.CnpjEmpresa}
                        Desabilitado={true}
                        state={solicitarBaixaMei.SolicitarBaixaMeiDados}
                      />
                    </Col>
                    {solicitarBaixaMei.FormaGerarSenha &&
                      solicitarBaixaMei.FormaGerarSenha != EnumFormaGerarSenha.NaoGerarSenhaAutorizacao && (
                        <Row>
                          <Col>
                            <DDadosItem name="Senha" {...Campos.Password} />
                          </Col>
                        </Row>
                      )}
                  </Row>
                </Modal.Body>
              </div>
            )}
          </Form>
        )}
      </>
    );
  }
}

export default connect({
  actions: {
    solicitarBaixaMeiActions,
  },
  selectors: {
    solicitarBaixaMeiSelector,
  },
})(Container);
